export function Plus() {
  return (
    <svg
      aria-hidden={true}
      viewBox="0 0 82.908935546875 81.7861328125"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="matrix(1 0 0 1 -11.280507812499991 76.123046875)">
        <path d="M12.4512-35.2539C12.4512-32.2266 14.9414-29.7852 17.9199-29.7852L47.8516-29.7852L47.8516 0.146484C47.8516 3.125 50.3418 5.61523 53.3203 5.61523C56.2988 5.61523 58.7891 3.125 58.7891 0.146484L58.7891-29.7852L88.7207-29.7852C91.6992-29.7852 94.1895-32.2266 94.1895-35.2539C94.1895-38.2324 91.6992-40.7227 88.7207-40.7227L58.7891-40.7227L58.7891-70.6543C58.7891-73.6328 56.2988-76.123 53.3203-76.123C50.3418-76.123 47.8516-73.6328 47.8516-70.6543L47.8516-40.7227L17.9199-40.7227C14.9414-40.7227 12.4512-38.2324 12.4512-35.2539Z"></path>
      </g>
    </svg>
  );
}
